export const checkScaleSchema = (schema) => {
  let errorMessage = "";

  const allSingleQuestionsSchema = schema.filter(q => q?.question);
  const allSingleQuestions = allSingleQuestionsSchema.map(q => q?.question);

  const allSectionsToDelete = schema.filter(s => s?.section?.to_delete);
  const allSectionQuestionsToDelete = allSectionsToDelete.flatMap(s => s?.section?.questions);
  const allQuestionsFromSectionsToDelete = allSectionQuestionsToDelete.map(q => ({ ...q, to_delete: true }));

  const allNormalSections = schema.filter(s => !s?.section?.to_delete);
  const allNormalSectionQuestions = allNormalSections.flatMap(s => s?.section?.questions);

  const questions = [...allSingleQuestions, ...allQuestionsFromSectionsToDelete, ...allNormalSectionQuestions];
  const questionsToCheck = questions.filter(q => !!q);
  const activeQuestions = questionsToCheck.filter(q => !q?.to_delete);
  const noQuestions = !questions.length || !questionsToCheck.length || !activeQuestions.length;
  if (noQuestions)
    errorMessage = "Agregue una pregunta";

  const { questionErrors, submitValidation } = checkQuestionSchema(schema);

  if (!!submitValidation.length)
    errorMessage = "Verifica el formulario, existe algún error";

  return { errorMessage, questionErrors, submitValidation };
};

const checkQuestionSchema = (questionList) => {
  let questionErrors = [];

  for (let item of questionList) {
    let error = {
      question: {},
    };

    if (item.question) {
      if (!item.question.to_delete) {
        !item.question.detail.length &&
          (error.question.detail =
            "Olvidaste diligenciar este campo");

        if (
          item.question.type === 2 ||
          item.question.type === 6 ||
          item.question.type === 1 ||
          item.question.type === 3
        ) {
          let questionsOptions = item?.question?.options;
          !questionsOptions.length &&
            (error.question.options = "Debes Añadir 1 opción");

          let questionFilter = questionsOptions?.filter(
            (question) => !question?.detail.length
          );

          questionFilter?.length &&
            (error.question.options =
              "Olvidaste diligenciar alguna de las opciones");
        }

        if (item.question.type === 12) {
          let ranges = item.question.ranges;
          ranges.filter((r) => r.detail.length).length < 2 &&
            (error.question.ranges = "Debes añadir los dos rangos");
        }
      }

      Object.keys(error).length
        ? questionErrors.push(error)
        : questionErrors.push(undefined);
    } else if (item.section) {
      let error = { section: {} };

      !item.section.name.length &&
        (error.section.name = "Olvidaste diligenciar este campo");

      if (!item.section.to_delete) {
        let questionsOptions = item.section.questions;
        let filteredQuestionOptions = questionsOptions.filter(q => !q?.to_delete);

        if (questionsOptions?.length) {
          const errorQ = [];

          for (let q of filteredQuestionOptions) {
            let questions = {};
            !q.detail.length &&
              (questions.detail =
                "Olvidaste diligenciar este campo");

            if (
              q.type === 2 ||
              q.type === 6 ||
              q.type === 1 ||
              q.type === 3
            ) {
              let questionsOptions = q.options;
              !questionsOptions.length &&
                (questions.options = "Debes Añadir 1 opción");

              let questionFilter = questionsOptions?.filter(
                (question) => !question?.detail.length
              );

              questionFilter?.length &&
                (questions.options =
                  "Olvidaste diligenciar alguna de las opciones");
            }

            if (q.type === 12) {
              let ranges = q.ranges;
              ranges.filter((r) => r.detail.length).length < 2 &&
                (questions.ranges = "Debes añadir los dos rangos");
            }

            Object.keys(questions).length
              ? errorQ.push(questions)
              : errorQ.push(undefined);
          }
          error.section.questions = errorQ;
        } else {
          error.section.questions = "Debes Añadir 1 opción";
        }
      }

      Object.keys(error).length
        ? questionErrors.push(error)
        : questionErrors.push(undefined);
    }
  }

  return {
    questionErrors,
    submitValidation: validateQuestionErrors(questionErrors),
  };
};

const validateQuestionErrors = (questionErrors = []) => {
  const submitValidation = [];

  for (let e of questionErrors) {
    if (e.question) {
      if (Object.keys(e.question).length) {
        submitValidation.push(e);
      }
    }
    if (e.section) {
      if (Object.keys(e.section).length) {
        const listQ = e.section.questions;
        const submitSection = listQ.filter((q) => q !== undefined);
        submitSection.length && submitValidation.push(submitSection);
      }
    }
  }

  return submitValidation;
}
